<script setup>  

</script>

<template>
    <div class="">
        <div role="status" class="flex items-center justify-center h-14 w-full bg-sky-100 rounded-lg animate-pulse mb-4"></div>
        <div role="status" class="flex items-center justify-center h-40 w-full bg-sky-100 rounded-lg animate-pulse"></div>
        <span class="sr-only">Loading...</span>
    </div>
</template>